import React, { useEffect, useRef, useState } from 'react';
import {
	ChartWrapper,
	TitleSection,
	TopContentWrapper,
	Wrapper,
} from '../shared.styles';
import { getWeeklyResignDeliverability } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import CustomSkeleton from '@/common/components/CustomSkeleton';
import Input from '@/common/components/Input';
import CustomLine from '@/common/charts/Line';
import SelectInput from '@/common/components/SelectInput';
import { OPTIONS } from './constants/options';
import * as moment from 'moment';

const TIME_TO = moment().weekday() > 4 ? 1 : 2;

const DeliveryResignMarket = () => {
	const [selectedDate, setSelectedDate] = useState(OPTIONS[2]);
	const [chartData, setChartData] = useState();
	const {
		commonData: { products },
	} = useCommonDataContext();
	const timeRangeRef = useRef();

	const { makeRequest } = useRequestsContext();

	const handleLoadData = async () => {
		setChartData(() => null);

		const payload = {};
		payload.timeFrom = timeRangeRef.current.value;
		payload.timeTo = TIME_TO;
		payload.date = 'confirmation_date';
		payload.resign_status = selectedDate.value;

		const response = await makeRequest(
			getWeeklyResignDeliverability.bind(null, payload),
		);

		if (response.data) {
			setChartData(() => response.data);
		}
	};

	useEffect(() => {
		if (products[0]) {
			handleLoadData();
		}
	}, [products]);

	return (
		<Wrapper width={800}>
			<TitleSection>
				<TopContentWrapper>
					<i className='fa-brands fa-usps' />
					Weekly market resign deliverability (%)
				</TopContentWrapper>
				<TopContentWrapper>
					<SelectInput
						selected={selectedDate}
						setSelected={setSelectedDate}
						options={OPTIONS}
						showLabel={false}
						selectWidth={200}
					/>
					<Input
						showLabel={false}
						inputWidth={50}
						value={TIME_TO}
						inputRef={timeRangeRef}
					/>
					<i
						class='fa-solid fa-arrows-rotate animation-scale'
						style={{ cursor: 'pointer' }}
						onClick={() => handleLoadData()}
					/>{' '}
				</TopContentWrapper>
			</TitleSection>
			<ChartWrapper>
				{chartData ? (
					<CustomLine
						data={chartData}
						options={{
							scales: {
								y: {
									type: 'linear',
									display: true,
									position: 'left',
								},
							},
						}}
					/>
				) : (
					<CustomSkeleton width={750} count={16} height={5} />
				)}
			</ChartWrapper>
		</Wrapper>
	);
};

export default DeliveryResignMarket;
